var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTrans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6133 23.3865L22.0667 19.9332C22.5867 19.4132 23.4267 19.4132 23.9467 19.9332L27.4 23.3865C28.24 24.2265 27.64 25.6665 26.4533 25.6665H19.5467C18.36 25.6665 17.7733 24.2265 18.6133 23.3865Z",
    fill: "#17AA40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 14.5,
    stroke: "#17AA40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTrans);
export default __webpack_public_path__ + "static/media/success_trans.b2b1d222f9cf70fae9edf1dc1c94f355.svg";
export { ForwardRef as ReactComponent };